import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import keys from 'lodash/keys';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';

import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';

import { RouterFacade } from '@cigna/shared/angular/core/router-state-data-access';

import { ShellFacade } from '@cigna/chcp/shell/data-access';
import {
  COOKIE_EXCEPTION_LIST,
  DEEPLINK_BLACKLIST,
} from '@cigna/chcp/shared/util';
import { Alertv2 } from '@cigna/chcp/shell/ui';
import { ChcpContentfulService } from '@cigna/chcp/shared/contentful-data-access';
import { take } from 'rxjs';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfig,
} from '@cigna/chcp/shared/environment-util';

@Component({
  selector: 'cigna-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  queryParams$ = this.routerFacade.queryParams$;

  publicAlerts: Alertv2[] = [];

  isAuth0Login: boolean;

  dialogRef: MatDialogRef<PageComponent>;

  constructor(
    private routerFacade: RouterFacade,
    private shellFacade: ShellFacade,
    private cookieService: CookieService,
    public dialog: MatDialog,
    private featureToggleFacade: FeatureTogglesFacade,
    private contentfulService: ChcpContentfulService,
    @Inject(ENVIRONMENT_CONFIG) private envConfig: EnvironmentConfig,
  ) {
    this.isAuth0Login = this.envConfig.authMethod === 'auth0';
  }
  ngOnInit() {
    this.shellFacade.reset();
    this.clearCookies();
    sessionStorage.clear();

    this.contentfulService
      .getAlerts('5NiwSs3q41zqv98BZo2MAz')
      .then((alerts) => (this.publicAlerts = alerts))
      .catch(() => {
        this.publicAlerts = [];
      });
  }

  clearCookies() {
    const allCookies: string[] = keys(this.cookieService.getAll());
    const deeplinkCookie: string = this.cookieService.get('CHCP_DEEPLINK');

    allCookies.forEach((cookieName) => {
      if (
        !COOKIE_EXCEPTION_LIST.some((exception) => exception.test(cookieName))
      ) {
        this.cookieService.delete(cookieName, '/');
      }
    });

    if (
      deeplinkCookie &&
      DEEPLINK_BLACKLIST.some((cookie) => cookie === deeplinkCookie)
    ) {
      this.cookieService.delete('CHCP_DEEPLINK', '/');
    }

    // clear analytics login success variable
    localStorage.setItem('adobeLoginSuccess', 'n');
  }

  openModal(container: TemplateRef<PageComponent>): void {
    this.dialogRef = this.dialog.open(container, {
      autoFocus: false,
      width: '600px',
    });
  }
}
